import { BackButtonContext } from 'contexts/BackButtonContext';
import React, { useContext, useEffect, useRef } from 'react';

import { BlankPage } from '../BlankPage';
import { PageHeader } from '../PageHeader';
import { useResponsiveStyles } from '../PageHeader/styles';
import { HeaderPageProps } from './types';
import { DocumentationLinkProvider } from '../PageHeader/DocumentationLinkProvider';

const HeaderPage: React.FunctionComponent<HeaderPageProps> = (props) => {
  const { children, headerProps } = props;
  const { setBackButton } = useContext(BackButtonContext);
  const breakpointRef = useRef<HTMLDivElement>(null);
  const responsiveClasses = useResponsiveStyles(breakpointRef);

  useEffect(() => {
    setBackButton(headerProps.backButton);
  }, [headerProps.backButton, setBackButton]);

  const renderHeaderPage = () => {
    return (
      <DocumentationLinkProvider>
        <BlankPage reference={breakpointRef}>
          <PageHeader
            classes={{
              headerTitleWrapper: responsiveClasses.headerTitleWrapper,
            }}
            key='pageHeader'
            {...headerProps}
          />
          {children}
        </BlankPage>
      </DocumentationLinkProvider>
    );
  };

  return renderHeaderPage();
};

export default HeaderPage;
